import React, { useState } from 'react';
import RemoveConfirmationModal from '../../../../Components/RemoveConfirmation/RemoveConfirmationModal';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import { useAppContext } from '../../../../Services/AppContext';

interface HealthPlanPrintPdfModalProps {
	opened: boolean;
	onClose: any;
	healthPlanUser: any;
	healthPlanUserItem: any;
}

export default function HealthPlanPrintPdfModal(
	props: HealthPlanPrintPdfModalProps,
) {
	const { opened, onClose, healthPlanUser, healthPlanUserItem } = props;
	const { socketUrl } = useAppContext();

	const handleConfirm = () => {
		window.open(
			socketUrl +
				'/health-plan/' +
				healthPlanUser?.healthPlanId +
				'/user/' +
				healthPlanUser?.id +
				'/item/' +
				healthPlanUserItem?.id +
				'/pdf?print&withPermit',
			'_blank',
		);
	};

	return (
		<>
			<RemoveConfirmationModal
				opened={opened}
				onClose={onClose}
				onConfirm={handleConfirm}
				confirmationText={'base.printWindow.text'}
				confirmationTitle={'base.printWindow.title'}
				customButtons={(onClose: any) => (
					<React.Fragment>
						<Button
							onClick={() => {
								onClose();
								handleConfirm();
							}}
							title={'base.shared.confirm'}
							theme={Theme.GREEN}
						/>
						<Button
							onClick={() => {
								onClose();
							}}
							title={'base.shared.cancel'}
							theme={Theme.RED}
						/>
					</React.Fragment>
				)}
				showAbort={false}
			/>
		</>
	);
}
